import React from 'react';

import Image from '../../Image';
import Container from '../../interface/Container';
import { CircleCtaButton } from '../HeaderMastheadHalfImage/HeaderMastheadHalfImage.styles';
import {
  CtaButton,
  ContentWrapper,
  ImageWrapper,
  Split,
  Text,
  Title,
  Wrapper,
} from './HeaderMastheadTwoColumns.styles';

const HeaderMastheadTwoColumns = ({ headerData }) => {
  const { title, image, headerText, linkTitle, ctaUrl, linkTitle2, ctaUrl2 } = headerData;

  return (
    <Wrapper>
      <Container>
        <Split>
          <ContentWrapper>
            <Title>{title}</Title>
            {headerText && <Text dangerouslySetInnerHTML={{ __html: headerText }} />}
            {linkTitle2 && ctaUrl2 && (
              <CtaButton href={ctaUrl2.url} type={ctaUrl2.type} size="large">
                {linkTitle2}
              </CtaButton>
            )}
          </ContentWrapper>
          <ImageWrapper>
            <Image image={image[0]} />
          </ImageWrapper>
        </Split>
      </Container>
      {linkTitle && ctaUrl && (
        <CircleCtaButton href={ctaUrl.url} type={ctaUrl.type}>
          {linkTitle}
        </CircleCtaButton>
      )}
    </Wrapper>
  );
};

export default HeaderMastheadTwoColumns;
